export default __webpack_public_path__ + "static/media/GuyAnimation2.bf54277f.svg";